import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { requestCompanyRegistration } from '../../types';

type initialStateType = {
    is_loading_company_registrations?: boolean;
    company_registrations_request?: Array<requestCompanyRegistration>;
    is_updating_company_registration_request?: boolean;
    is_adding_company_registration_request?: boolean;
    is_deleting_company_registration_request?: boolean;
};

const initialState: initialStateType = {
    is_loading_company_registrations: false,
    company_registrations_request: [],
    is_updating_company_registration_request: false,
    is_adding_company_registration_request: false,
    is_deleting_company_registration_request: false,
};

const companyRegistrationRequestSlice = createSlice({
    name: 'companyRegistrationRequest',
    initialState,
    reducers: {
        setCompanyRegistartionRequests: (state, action: PayloadAction<Array<requestCompanyRegistration>>) => {
            return {
                ...state,
                company_registrations_request: action.payload,
            };
        },
        onCompanyRegistartionRequestsUpdate: (state, action: PayloadAction<boolean>) => {
            return {
                ...state,
                is_updating_company_registration_request: action.payload,
            };
        },
        onAddingCompanyRegistartionRequests: (state, action: PayloadAction<boolean>) => {
            return {
                ...state,
                is_adding_company_registration_request: action.payload,
            };
        },
        onDeleteCompanyRegistartionRequests: (state, action: PayloadAction<boolean>) => {
            return {
                ...state,
                is_deleting_company_registration_request: action.payload,
            };
        },
    }
});

export const { setCompanyRegistartionRequests, onCompanyRegistartionRequestsUpdate, onAddingCompanyRegistartionRequests, onDeleteCompanyRegistartionRequests } = companyRegistrationRequestSlice.actions;

export default companyRegistrationRequestSlice.reducer;